import { observer } from 'mobx-react'
import { ReactNode, useEffect, useRef, useState } from 'react'

import { ReactComponent as ArrowDown } from '../../../../assets/arr-down.svg'
import useOnClickOutside from '../../../common/Select/useOnClickOutside'
import classNames from 'classnames'

const NewSelectMenu = observer(
  ({
    children,
    defaultValue,
  }: {
    children: ReactNode | ReactNode[]
    defaultValue: string | null
  }) => {
    const ref = useRef<any>(null)
    const [showDropdown, setShow] = useState(false)

    useOnClickOutside(ref, () => setShow(false))

    return (
      <>
        <div className="select-container" ref={ref}>
          <div
            className={showDropdown ? 'selected-text active' : 'selected-text'}
            onClick={() => setShow(!showDropdown)}
          >
            <span>{defaultValue}</span>
            <div className={classNames('select-icon', showDropdown && 'show-drop')}>
              {' '}
              <ArrowDown />
            </div>
          </div>
          <ul
            className={
              showDropdown
                ? 'select-options show-dropdown-options'
                : 'select-options hide-dropdown-options'
            }
          >
            {children !== defaultValue && children}
          </ul>
        </div>
      </>
    )
  },
)

export default NewSelectMenu
